<style scoped>
.fadeOut {
    opacity: 1;
    transition: 0.5s opacity ease-in-out;
}
.fadeOut.fadeOutEnd {
    opacity: 0;
}
.fadeOut.fadeOutHide {
    display: none;
}
</style>
<template>
    <Promised :pending-delay="null" :promise="promise" v-if="promise != null">
        <template #pending>
            <slot name="pending" v-bind="$attrs">
                <LoadingWheel :width="16" style="display: inline-block" v-bind="$attrs" />
            </slot>
        </template>
        <template #rejected="error">
            <slot name="rejected" v-bind:error="error" v-bind="$attrs"
                ><span v-bind="$attrs"><span class="icon icon-attention" style="color: red"></span><span class="sr-only">FAILED</span></span></slot
            >
        </template>
        <template v-slot="data">
            <slot v-bind:data="data" v-bind="$attrs">
                <span v-bind="$attrs">
                    <span class="icon icon-check fadeOut" :class="{ fadeOutEnd: fade, fadeOutHide: !display, 'd-none': hideInsideCheckIcon }"></span>
                    <span class="sr-only">Done</span>
                </span>
            </slot>
        </template>
    </Promised>
</template>
<script lang="ts">
import { defineComponent, /*defineProps,*/ ref, watch, nextTick, computed } from "vue";
import LoadingWheel from "./LoadingWheel.3.vue";
import { Promised } from "@/lib/Promised";
interface Props {
    promise: Promise<any> | null | undefined; //eslint-disable-line @typescript-eslint/no-explicit-any
    hideCheckIcon?: boolean;
}
export default defineComponent({
    components: {
        Promised,
        LoadingWheel,
    },
    inheritAttrs: false,
    props: ["promise", "hideCheckIcon"],
    setup(props: Props) {
        //defineProps<Props>();

        const fade = ref<boolean>(false);
        const display = ref<boolean>(false);

        const hideInsideCheckIcon = computed(() => props.hideCheckIcon != undefined && props.hideCheckIcon !== false);

        // Because passing watch a bare promise causes it to be resolved without a catch
        const promiseWrapper = computed(() => ({ promise: props.promise }));

        watch(
            () => promiseWrapper.value,
            ({ promise: newPromise }) => {
                fade.value = false;
                display.value = true;
                if (newPromise != null) {
                    newPromise
                        .then(() => {
                            nextTick(() => {
                                setTimeout(() => {
                                    fade.value = true;
                                    setTimeout(() => {
                                        display.value = false;
                                    }, 500);
                                }, 1500);
                            });
                        })
                        .catch(() => {});
                }
            },
        );

        return {
            fade,
            display,
            hideInsideCheckIcon,
        };
    },
});
</script>
